import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {Helmet} from "react-helmet";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';



const Blogs = () => {

    const [posts, setPosts] = useState([]);
    const [page, setPage] = useState(1);

    const fetchMoreData = () => {
        // Increment the page number when fetching more data
        const nextPage = page + 1;
    
        // Fetch additional posts from WordPress REST API
        axios.get(`https://notesbynani.com/wp-json/wp/v2/posts?page=${nextPage}`)
          .then(response => {
            setPosts([...posts, ...response.data]);
            setPage(nextPage);
          })
          .catch(error => {
            console.error('Error fetching more posts:', error);
          });
      };
    

  useEffect(() => {
    // Fetch posts from WordPress REST API
    axios.get('https://notesbynani.com/wp-json/wp/v2/posts')
      .then(response => {
        setPosts(response.data);
      })
      .catch(error => {
        console.error('Error fetching posts:', error);
      });
  }, []);
    return (<>
     <Helmet>
                <meta charSet="utf-8" />
                <title>Blogs</title>
                <link rel="canonical" href="http://mysite.com/example" />
                {/* <script>
    window.sr = new scrollReveal();

   
    </script> */}
            </Helmet>;
            <h1>Blog Articles</h1>
            <InfiniteScroll
        dataLength={posts.length}
        next={fetchMoreData}
        hasMore={true}
        loader={<h4>Loading...</h4>}
      >
            <ul className='postlist'>
        {posts.map(post => (
            <li key={post.id} id={post.id}>
          {/* <a href={post.link} target='_blank'> */}
          <Link to={`/postsbyid/${post.id}`}>
          <img src={post.jetpack_featured_media_url} alt="" />
          {post.title.rendered}
          {/* </a> */}
          </Link>
          </li>
        ))}
      </ul>
      </InfiniteScroll>
            </>) };
  
  export default Blogs;
